import { Controller } from "@hotwired/stimulus"
import currency from "currency.js"

export default class extends Controller {
  static targets = [
    "code",
    "message",
    "codeSummary",
    "originalSubtotal",
    "discountAmount",
    "discountedSubtotal",
    "platformFeeTotal",
    "paymentProviderFeeTotal",
    "firewoodFeeTotal",
    "subtotalRegular",
    "grandTotal",
    "paymentElement"
  ]

  apply(event) {
    event.preventDefault()
    const discountCode = this.codeTarget.value.trim().toUpperCase()
    if (discountCode === "") {
      this.messageTarget.innerHTML = "Please enter a discount code."
      return
    }
    fetch("/carts/apply_discount_code", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ code: discountCode })
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          this.messageTarget.innerHTML = data.error
        } else {
          // Calculate formatted amounts.
          const originalSubtotalValue = data.new_subtotal + data.discount_cents
          const formattedOriginalSubtotal = currency(originalSubtotalValue, { fromCents: true, symbol: '$', precision: 2 }).format()
          const formattedDiscountedSubtotal = currency(data.new_subtotal, { fromCents: true, symbol: '$', precision: 2 }).format()
          const formattedDiscountAmount = currency(data.discount_cents, { fromCents: true, symbol: '$', precision: 2 }).format()
          const formattedGrandTotal = currency(data.total_price, { fromCents: true, symbol: '$', precision: 2 }).format()
         
          const formattedPlatformFeeTotal = currency(data.fee_total_cents, { fromCents: true, symbol: '$', precision: 2 }).format()
          const formattedPaymentProviderFeeTotal = currency(data.payment_provider_fee_cents, { fromCents: true, symbol: '$', precision: 2 }).format()
          const formattedFirewoodFeeTotal = currency(data.firewood_fee_cents, { fromCents: true, symbol: '$', precision: 2 }).format()

          this.messageTarget.innerHTML = `Discount ${data.discount_code} applied successfully.`

          // Update payment details with discount
          if (this.paymentElementTarget) {
            this.paymentElementTarget.dispatchEvent(new CustomEvent("discount:applied", { bubbles: true }));
            console.log("REAL MONSTERS")
          }

          // Update discount details in the UI
          if (this.hasCodeSummaryTarget) {
            this.codeSummaryTarget.innerHTML = data.discount_code
          }
          if (this.hasOriginalSubtotalTarget) {
            this.originalSubtotalTarget.innerHTML = formattedOriginalSubtotal
          }
          if (this.hasDiscountAmountTarget) {
            this.discountAmountTarget.innerHTML = formattedDiscountAmount
          }
          if (this.hasDiscountedSubtotalTarget) {
            this.discountedSubtotalTarget.innerHTML = formattedDiscountedSubtotal
          }

          if (this.hasPlatformFeeTotalTarget) {
            this.platformFeeTotalTarget.innerHTML = formattedPlatformFeeTotal
          }
          if (this.hasPaymentProviderFeeTotalTarget) {
            this.paymentProviderFeeTotalTarget.innerHTML = formattedPaymentProviderFeeTotal
          }
           if (this.hasFirewoodFeeTotalTarget) {
            this.firewoodFeeTotalTarget.innerHTML = formattedFirewoodFeeTotal
          }
          if (this.hasGrandTotalTarget) {
            this.grandTotalTargets.forEach(target => {
              target.innerHTML = formattedGrandTotal
            })
          }

          // Toggle summary sections: show discount details and hide regular subtotal.
          const discountSummary = document.getElementById("discount-summary")
          const regularSummary = document.getElementById("regular-summary")
          if (discountSummary && regularSummary) {
            discountSummary.style.display = "block"
            regularSummary.style.display = "none"
          }

          // Replace the discount section markup with a non-editable applied discount.
          const discountSection = document.getElementById("discount")
          discountSection.innerHTML = `
            <h3>Applied Discount Code</h3>
            <div class="applied-discount">
              <input type="text" name="code" value="${data.discount_code}" disabled data-discount-target="code">
              <button type="button" data-action="click->discount#remove">Remove Discount</button>
            </div>
            <div data-discount-target="message"></div>
          `
        }
      })
      .catch(error => {
        console.log(error);
        this.messageTarget.innerHTML = "An error occurred while applying the discount."
      })
  }

  remove() {
    fetch("/carts/remove_discount_code", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => response.json())
      .then(data => {
        // Update the regular summary subtotal.

        const formattedPlatformFeeTotal = currency(data.fee_total_cents, { fromCents: true, symbol: '$', precision: 2 }).format()
        const formattedPaymentProviderFeeTotal = currency(data.payment_provider_fee_cents, { fromCents: true, symbol: '$', precision: 2 }).format()
        const formattedFirewoodFeeTotal = currency(data.firewood_fee_cents, { fromCents: true, symbol: '$', precision: 2 }).format()


        if (this.paymentElementTarget) {
          console.log("AHHHH")
          this.paymentElementTarget.dispatchEvent(new CustomEvent("discount:removed", { bubbles: true }));
        }

        if (this.hasSubtotalRegularTarget) {
          const formattedSubtotalRegular = currency(data.new_subtotal, { fromCents: true, symbol: '$', precision: 2 }).format()
          this.subtotalRegularTarget.innerHTML = formattedSubtotalRegular
        }
        if (this.hasPlatformFeeTotalTarget) {
          this.platformFeeTotalTarget.innerHTML = formattedPlatformFeeTotal
        }
        if (this.hasPaymentProviderFeeTotalTarget) {
          this.paymentProviderFeeTotalTarget.innerHTML = formattedPaymentProviderFeeTotal
        }
         if (this.hasFirewoodFeeTotalTarget) {
          this.firewoodFeeTotalTarget.innerHTML = formattedFirewoodFeeTotal
        }
        if (this.hasGrandTotalTarget) {
          this.grandTotalTargets.forEach(target => {
            const formattedGrandTotal = currency(data.total_price, { fromCents: true, symbol: '$', precision: 2 }).format()
            target.innerHTML = formattedGrandTotal
          })
        }

        // Hide the discount details and show the regular summary.
        const discountSummary = document.getElementById("discount-summary")
        const regularSummary = document.getElementById("regular-summary")
        if (discountSummary && regularSummary) {
          discountSummary.style.display = "none"
          regularSummary.style.display = "block"
        }

        // Restore the discount section with the editable apply discount form.
        const discountSection = document.getElementById("discount")
        discountSection.innerHTML = `
          <h3>Apply Discount Code</h3>
          <form data-action="submit->discount#apply">
            <input type="text" name="code" placeholder="Enter discount code" data-discount-target="code">
            <button type="submit">Apply</button>
          </form>
          <div data-discount-target="message"></div>
        `
        this.messageTarget.innerHTML = "Discount removed. You can apply a new discount code."
      })
      .catch(error => {
        console.log(error);
        this.messageTarget.innerHTML = "An error occurred while removing the discount."
      })
  }
}
